import {
    BackButton,
    Divider,
    Form,
    FormDate,
    FormDropDown,
    Header,
    setAttributeEntity,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileDriverCriminalConviction = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    return (
        <React.Fragment>
            <BackButton clickEvent={props.backEvent} />
            <Divider top={sizes.md} />
            <Header
                size={sizes.md}
                textAlign={alignments.left}
                text={<FormattedMessage id='Profile_Drivers_CriminalConviction.criminalConviction' />}
            />
            <Form
                label={<FormattedMessage id='Profile_Drivers_CriminalConviction.criminalConvictionDetails' />}
                allowEdit={props.allowEdit}
                saveEvent={() => props.doUpsertPolicy()}
                cancelEvent={() => props.doGetPolicy()}
            >
                <FormDate
                    label={<FormattedMessage id='Profile_Drivers_CriminalConviction.dateOfConviction' />}
                    value={props.criminalConviction?.eventDate}
                    changeEvent={(value) => props.doReducePolicyElement({ code: `${props.dotProp}eventDate`, value })}
                    culture={props.context.session.culture}
                    mode='past'
                    allowEdit
                />
                <FormDropDown
                    label={<FormattedMessage id='Profile_Drivers_CriminalConviction.convictionReason' />}
                    value={props.criminalConviction?.reason}
                    references={props.reference.references?.CriminalConvictions}
                    referencesEvent={() => props.reference.doGetReferences('CriminalConvictions')}
                    changeEvent={(value) =>
                        setAttributeEntity(`${props.dotProp}reason`, value, props.doReducePolicyElement)
                    }
                    allowEdit
                />
            </Form>
        </React.Fragment>
    );
};

export default ProfileDriverCriminalConviction;
